import {
    Component,
    EventEmitter,
    Inject,
    Input,
    OnInit,
    Output,
    ViewEncapsulation
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import {
    CalendarDateFormatter,
    CalendarEvent,
    CalendarEventAction,
    CalendarEventTimesChangedEvent,
    CalendarEventTitleFormatter,
    CalendarMonthViewDay
} from 'angular-calendar';
import { isSameDay, isSameMonth, startOfDay } from 'date-fns';
import {
    map as _map,
    filter,
    findIndex,
    forEach,
    indexOf
} from 'lodash';
import { Observable, Subject, Subscription } from 'rxjs';

import { PlatfromConfirmDialogComponent } from '@ecap3/app-platform-confirm-dialog';

import { EcapTranslateService, UserInfoService } from '@ecap3/core';
import { TranslateService } from '@ngx-translate/core';
import * as _moment from 'moment';
import { take, takeUntil } from 'rxjs/operators';
import { Person } from 'src/app/shared/models/ecap.model';
import { ScheduleCalendarService } from '../../../../shared/services/schedule-calendar.service';
import { SCHEDULE_EVENT_FILTER_KEY, schedulesEmployeeActionStatus } from '../../../app-schedule/constants/schedule-event.constant';
import {
    CalendarConfigModel,
    CalendarEventModel
} from '../../models/calendar.model';
import { CustomDateFormatter } from '../../providers/custom-date-formatter.provider';
import { CustomEventTitleFormatter } from '../../providers/custom-event-title-formatter.provider';
import { PlatfromCalendarService } from '../../services/platform-calendar.service';
import { PlatfromCalendarEventFormDialogComponent } from '../event-form/event-form.component';

const defaultLanguages = {
    en: {
        key: 'en',
        value: 'en-US'
    },
    de: {
        key: 'de',
        value: 'de-DE'
    },
    fr: {
        key: 'fr',
        value: 'fr-FR'
    },
    it: {
        key: 'it',
        value: 'it-IT'
    }
};
@Component({
    selector: 'app-platform-calendar',
    templateUrl: './platform-calendar.component.html',
    styleUrls: ['./platform-calendar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: CalendarDateFormatter,
            useClass: CustomDateFormatter
        },
        {
            provide: CalendarEventTitleFormatter,
            useClass: CustomEventTitleFormatter
        }
    ]
})
export class PlatformCalendarComponent implements OnInit {
    @Input() calendarConfig: CalendarConfigModel;
    @Input() changePersonEventSubject: Observable<any>;
    @Input() bottomSheetClosedSubject: Observable<any>;
    @Output() syncCalendarEvents = new EventEmitter<any>();

    viewTypes = [
        {
            key: 'MONTHLY',
            value: 'month'
        },
        {
            key: 'SCHEDULE',
            value: 'schedule'
        },
        {
            key: 'WEEKLY',
            value: 'week'
        }
    ];
    schedulesEmployeeActionStatus = schedulesEmployeeActionStatus;
    embeddedInfoStatus = {
        ...schedulesEmployeeActionStatus,
        booked: 'booked',
        scheduled: 'scheduled',
        reserved: 'reserved',
        invited: 'invited'
    }
    selectedViewType;
    isScheduleView = true;
    currentMonthName;
    nextSecondMonthName;
    currentYear;
    nextYear;
    previousYear;
    formatedSchedulesForListView = [];
    startDateForScheduleView;
    endDateForScheduleView;

    view: string;
    viewDate: Date;
    events: CalendarEvent[] = [];
    public actions: CalendarEventAction[];
    activeDayIsOpen: boolean;
    refresh: Subject<any> = new Subject();
    dialogRef: any;
    calendarHeader: any;
    hasPermissionToAddEvent = false;
    loadingEvents = true;
    currentMonth: any;
    confirmDialogRef: MatDialogRef<PlatfromConfirmDialogComponent>;
    selectedDay: any;
    selectedWeekInSameMonth = true;
    enabledViews: any;
    views = this.calendarService.getCalendarViews();
    weekStartsOn: number;
    weekendDays: number[];
    calendarEventDownload: any;
    locale = 'en-US';
    createNewEventSubscribe: any;
    editEventSubscribe: any;
    deleteEventSubscribe: any;
    getCalendarEventsSubscribe: any;
    OnEventDeletedSubscibe: any;
    OnEventAddedSubscribe: any;
    onEventUpdatedSubscribe: any;
    OnReloadSubscibe: any;
    languages: any;
    changePersonEventSubscription: Subscription;
    personInfo: any;

    private _unsubscribeAll: Subject<any> = new Subject();

    constructor(
        @Inject('IAppPlatformCalendar') private IAppPlatformCalendar,
        public dialog: MatDialog,
        public calendarService: PlatfromCalendarService,
        private scheduleCalendarService: ScheduleCalendarService,
        private activatedRouted: ActivatedRoute,
        private translateService: TranslateService,
        private ecapTranslateService: EcapTranslateService,
        private userInfoService: UserInfoService
    ) {
        this.view = 'schedule';
        this.viewDate = new Date();
        this.activeDayIsOpen = true;
        this.selectedDay = { date: startOfDay(new Date()) };
        this.getPersonInfo();
    }

    ngOnInit(): void {
        sessionStorage.removeItem(SCHEDULE_EVENT_FILTER_KEY);

        this.subscribeToActivatedRoute();

        this.setCalendarData();
        this.subscribeToEventUpdate();
        this.subscribeToEventAdd();
        this.subscribeToEventDelete();
        this.subscribeToReloadEvent();
        this.subscribeToLanguageChange();
        this.handlePersonChangeAndFetchEvents();

        this.scheduleCalendarService.dateRange.next(this.scheduleStartDate);
        this.scheduleCalendarService.calendarView.next(this.view);
        this.subscribeForBottomSheetCloseEvent();
    }

    private subscribeToEventUpdate(): void {
        this.onEventUpdatedSubscribe =
            this.calendarService.onEventUpdated.subscribe(
                (updatedEvent: CalendarEventModel) => {
                    if (
                        this.calendarConfig?.resetEventsAfterUpdated
                    ) {
                        if (this.isScheduleView) {
                            this.getScheduleTabEvents(this.scheduleStartDate);
                        } else {
                            this.getEvents();
                        }
                        this.refresh.next(true);
                    } else {
                        const eventIndex = findIndex(this.events, (event: any) => {
                            return event.itemId == updatedEvent.itemId;
                        });
                        this.events[eventIndex] = Object.assign(
                            this.events[eventIndex],
                            updatedEvent
                        );
                        this.refresh.next(true);
                    }
                }
            );
    }

    private  subscribeToEventAdd(): void {
        this.OnEventAddedSubscribe =
            this.calendarService.OnEventAdded.subscribe(
                (newEvent: CalendarEventModel) => {
                    newEvent.actions =
                        this.actions?.length
                            ? this.actions
                            : null;
                    this.events.push(newEvent);
                    this.refresh.next(true);
                }
            );
    }

    private subscribeToEventDelete(): void {
        this.OnEventDeletedSubscibe =
            this.calendarService.OnEventDeleted.subscribe(
                (event: CalendarEventModel) => {
                    const eventIndex = this.events.indexOf(event);
                    this.events.splice(eventIndex, 1);
                    this.refresh.next(true);
                }
            );
    }

    private subscribeToReloadEvent(): void {
        this.OnReloadSubscibe = this.calendarService.OnReloadRequired.subscribe(
            (payload) => {
                if (this.isScheduleView) {
                    this.getScheduleTabEvents(this.scheduleStartDate);
                } else {
                    this.getEvents(null, payload);
                }
            }
        );
    }

    private subscribeToActivatedRoute(): void {
        let getToken = false;
        this.activatedRouted.queryParams
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((params) => {
                if (params) {
                    this.selectedViewType = params['view']
                        ? params['view']
                        : 'schedule';

                    if (params['view'] === 'week') {
                        this.isScheduleView = false;
                        this.view = 'week';
                    } else {
                        this.isScheduleView = true;
                        this.view = 'schedule';
                    }
                }
                if (params?.code && !getToken && this.calendarConfig) {
                    getToken = true;
                    this.OnGetCronofyCode({
                        Events: this.events,
                        Code: params.code
                    });
                }
            });
    }

    private subscribeToLanguageChange(): void {
        const currentLang =
            this.ecapTranslateService.getTranslate().currentLang;
        const selectedLang: any = this.languages[currentLang];
        this.locale = selectedLang?.value;

        this.translateService.onLangChange.pipe(takeUntil(this._unsubscribeAll)).subscribe((change) => {
            const selectedLang = this.languages[change.lang];
            this.locale = selectedLang?.value;

            if (this.isScheduleView) {
                this.getNextTwoMonthDates(this.scheduleStartDate);
            }

            this.IAppPlatformCalendar.getCalendarEventsOnLangChange(
                this.events
            ).pipe(takeUntil(this._unsubscribeAll)).subscribe((translatedEvents) => {
                this.events = translatedEvents;
                if (this.isScheduleView) {
                    this.getEventsForListView(this.scheduleStartDate);
                }
                this.refresh.next(null as any);
            });
        });
    }

    private handlePersonChangeAndFetchEvents(): void {
        if (this.changePersonEventSubject) {
            this.changePersonEventSubscription =
                this.changePersonEventSubject.subscribe((person) => {
                    this.personInfo = person;
                    if (this.isScheduleView) {
                        this.getScheduleTabEvents(this.scheduleStartDate);
                    } else {
                        this.getEvents();
                    }
                });
        } else if (this.isScheduleView) {
            this.getScheduleTabEvents(this.scheduleStartDate);
        } else {
            this.getEvents();
        }
    }

    private setCalendarData(): void {
        this.calendarHeader =
            this.calendarConfig?.HeaderLangKey ||
            'CALENDAR_HEADER';
        this.viewDate =
            this.calendarConfig?.viewDate || new Date();
        this.weekStartsOn = Number(this.calendarConfig?.weekStartsOn ?? 0);
        this.weekendDays = this.calendarConfig?.weekendDays || [0];
        this.activeDayIsOpen =
            this.calendarConfig?.activeDayIsOpen;
        this.selectedDay =
            this.calendarConfig?.selectedDay
                ? { date: startOfDay(new Date(this.calendarConfig.selectedDay)) }
                : { date: startOfDay(new Date()) };
        this.hasPermissionToAddEvent =
            this.calendarConfig?.hasPermissionToAddEvent;
        this.calendarEventDownload =
            this.calendarConfig?.calendarEventDownload;
        this.languages =
            this.calendarConfig?.Languages ||
            defaultLanguages;
        this.enabledViews = this.getEnabledViews();
        this.currentMonth = this.viewDate.getMonth();
        this.actions = this.getEventActions();
    }

    private subscribeForBottomSheetCloseEvent() {
        if (this.bottomSheetClosedSubject) {
            this.scheduleCalendarService.isBottomSheetClosed.pipe(takeUntil(this._unsubscribeAll)).subscribe(
                (res) => {
                    if (res) this.resetEventCSS();
                }
            );
        }
    }

    getPersonInfo() {
        this.userInfoService
            .getLoggedInPersonInfo()
            .pipe(take(1))
            .subscribe((person: Person) => {
                console.log('Person', person);
                this.personInfo = person;
            });
    }

    setQueryParams(type) {
        this.calendarService.setQueryParams(type);
    }

    getEnabledViews() {
        const enabledView = {
            day:
                indexOf(
                    this.calendarConfig?.enabledViews,
                    this.views.day
                ) > -1,
            week:
                indexOf(
                    this.calendarConfig?.enabledViews,
                    this.views.week
                ) > -1,
            month:
                indexOf(
                    this.calendarConfig?.enabledViews,
                    this.views.month
                ) > -1
        };
        return enabledView;
    }

    getEventActions() {
        const action = [];
        if (this.calendarConfig?.EditEvent) {
            if (this.calendarConfig?.EditEventCustom) {
                action.push({
                    label: '<i class="material-icons calendar-edit-icon s-16">edit</i>',
                    a11yLabel: 'Edit',
                    onClick: ({ event }: { event: CalendarEvent }): void => {
                        this.editEventCustom('edit', event);
                    }
                });
            } else {
                action.push({
                    label: '<i class="material-icons calendar-edit-icon s-16">edit</i>',
                    a11yLabel: 'Edit',
                    onClick: ({ event }: { event: CalendarEvent }): void => {
                        this.editEvent('edit', event);
                    }
                });
            }
        }
        if (this.calendarConfig?.DeleteEvent) {
            if (this.calendarConfig?.DeleteEventCustom) {
                action.push({
                    label: '<i class="material-icons calendar-delete-icon s-16">delete</i>',
                    a11yLabel: 'Delete',
                    onClick: ({ event }: { event: CalendarEvent }): void => {
                        this.deleteEventCustom(event);
                    }
                });
            } else {
                action.push({
                    label: '<i class="material-icons calendar-delete-icon s-16">delete</i>',
                    a11yLabel: 'Delete',
                    onClick: ({ event }: { event: CalendarEvent }): void => {
                        this.deleteEvent(event);
                    }
                });
            }
        }
        return action;
    }

    removeEditDeleteOption(event) {
        if (event.emebeddedInfo.isProjectScheduled) {
            event.actions = event.actions.filter(
                (action) =>
                    !action.label.includes('delete') &&
                    !action.label.includes('edit')
            );
        }
        return event;
    }

    setActionAccordingToParameter(event) {
        let formatedActions = null;
        if (event.actions && this.actions?.length) {
            formatedActions = [];
            event.actions.forEach((eventAction) => {
                const selectedAction = this.actions.filter(
                    (action) => action.a11yLabel === eventAction.a11yLabel
                );
                formatedActions = [...formatedActions, ...selectedAction];
            });
        }
        return formatedActions;
    }

    getScheduleTabEvents(startDate) {
        this.loadingEvents = true;
        this.getCalendarEventsSubscribe =
            this.IAppPlatformCalendar.getCalendarEvents(
                startDate,
                null,
                this.personInfo,
                this.view,
                null
            )
                .pipe(take(1))
                .subscribe((eventsResult) => {
                    forEach(eventsResult, (event) => {
                        event.actions =
                            this.setActionAccordingToParameter(event); // event action control from outside
                    });
                    this.setEvents(eventsResult);
                    console.log({eventsResult});
                    if (this.isScheduleView) {
                        this.getEventsForListView(startDate);
                    }

                    this.loadingEvents = false;
                    this.refresh.next(null as any);
                });
    }

    scheduleStartDate: _moment.Moment = _moment();
    adjustSchedule(monthsToAddOrSubtract: number) {
        this.scheduleStartDate = _moment(this.scheduleStartDate).add(
            monthsToAddOrSubtract,
            'months'
        );
        this.scheduleCalendarService.dateRange.next(this.scheduleStartDate);
        // console.log(this.scheduleStartDate);
        this.getScheduleTabEvents(this.scheduleStartDate);
    }

    getEvents(daysOfMonthInCalendarBody?, payload?) {
        this.loadingEvents = true;
        this.getCalendarEventsSubscribe =
            this.IAppPlatformCalendar.getCalendarEvents(
                this.viewDate,
                daysOfMonthInCalendarBody,
                this.personInfo,
                this.view,
                payload
            )
                .pipe(take(1))
                .subscribe((eventsResult) => {
                    forEach(eventsResult, (event) => {
                        event.actions =
                            this.setActionAccordingToParameter(event); // event action control from outside
                    });
                    this.setEvents(eventsResult);
                    if (this.isScheduleView) {
                        this.getEventsForListView(this.scheduleStartDate);
                    }

                    this.loadingEvents = false;
                    this.refresh.next(null as any);
                });
    }

    setEvents(eventsResult) {
        const eventCollection = [];
        eventsResult.forEach((event) => {
            //  eventCollection.push(this.removeEditDeleteOption(event));
            eventCollection.push(event);
        });
        this.events = eventCollection;
        //  eventsResult = eventCollection;
        // if (!this.selectedWeekInSameMonth) {
        //     Array.prototype.push.apply(this.events, eventsResult);
        // } else {
        //     this.events = eventsResult;
        // }
    }

    beforeMonthViewRender({ header, body }) {
        const daysInMonth = filter(body, (day) => {
            return day.inMonth === true;
        });
        const selectedMonth = daysInMonth[0].date.getMonth();

        if (!this.loadingEvents && this.currentMonth !== selectedMonth) {
            this.currentMonth = daysInMonth[0].date.getMonth();
            this.selectedWeekInSameMonth = true;
            if (this.calendarService.fromEmModule.getValue()) {
                this.calendarService.OnCalendarViewChanged();
            } else {
                this.getEvents(daysInMonth);
            }
        }

        const _selectedDay = body.find((_day) => {
            return _day.date.getTime() === this.selectedDay.date.getTime();
        });

        if (_selectedDay) {
            _selectedDay.cssClass = 'mat-elevation-z3';
        }
    }

    beforeWeekViewRender({ header, body }) {
        const daysInWeek = _map(header, 'date');
        const weekStartMonth = daysInWeek[0].getMonth();
        const weekEndMonth = daysInWeek[6].getMonth();
        this.selectedWeekInSameMonth =
            weekStartMonth === weekEndMonth;
        const selectedMonth =
            weekStartMonth == weekEndMonth ? weekStartMonth : weekEndMonth;

        if (!this.loadingEvents && this.currentMonth !== selectedMonth) {
            this.currentMonth = daysInWeek[6].getMonth();
            if (this.calendarService.fromEmModule.getValue()) {
                this.calendarService.OnCalendarViewChanged();
            } else {
                this.getEvents(daysInWeek);
            }
        }

        const _selectedDay = header.find((_day) => {
            return _day.date.getTime() === this.selectedDay.date.getTime();
        });

        if (_selectedDay) {
            _selectedDay.cssClass = 'mat-elevation-z3';
        }
    }

    beforeDayViewRender({ header, body }) {
        const selectedMonth = this.viewDate.getMonth();
        if (!this.loadingEvents && this.currentMonth !== selectedMonth) {
            this.currentMonth = selectedMonth;
            if (this.calendarService.fromEmModule.getValue()) {
                this.calendarService.OnCalendarViewChanged();
            } else {
                this.getEvents();
            }
        }
    }

    dayClicked(day: CalendarMonthViewDay): void {
        const date: Date = day.date;
        const events: CalendarEvent[] = day.events;
        if (isSameMonth(date, this.viewDate)) {
            if (
                (isSameDay(this.viewDate, date) &&
                    this.activeDayIsOpen === true) ||
                events.length === 0
            ) {
                this.activeDayIsOpen = false;
            } else {
                this.activeDayIsOpen = true;
                this.viewDate = date;
            }
        }
        this.selectedDay = day;
        this.refresh.next(null as any);
    }

    eventTimesChanged({
        event,
        newStart,
        newEnd
    }: CalendarEventTimesChangedEvent): void {
        event.start = newStart;
        event.end = newEnd;
        this.refresh.next(true);
    }

    deleteEvent(event) {
        // this.confirmDialogRef = this.dialog.open(
        //     PlatfromConfirmDialogComponent,
        //     {
        //         disableClose: false
        //     }
        // );
        // this.confirmDialogRef.componentInstance.confirmMessage =
        //     'Are you sure you want to delete?';
        // this.confirmDialogRef.afterClosed().subscribe((result) => {
        //     if (result) {
        //         this.deleteEventDefault(event);
        //     }
        //     this.confirmDialogRef = null;
        // });
    }

    deleteEventDefault(event) {
        this.deleteEventSubscribe = this.IAppPlatformCalendar.deleteEvent(
            event
        ).subscribe((event: CalendarEventModel) => {
            const eventIndex = this.events.indexOf(event);
            this.events.splice(eventIndex, 1);
            this.refresh.next(true);
        });
    }

    deleteEventCustom(event: CalendarEvent) {
        this.calendarConfig?.deleteEventCustomCallback(
                event,
                this.calendarConfig
            );
    }

    editEventCustom(action: string, event: CalendarEvent) {
        const eventIndex = this.events.indexOf(event);
        this.calendarConfig?.editEventCustomCallback(
                event,
                this.calendarConfig
            );
    }

    editEventDefault(event, updatedEvent) {
        this.editEventSubscribe = this.IAppPlatformCalendar.editEvent(
            updatedEvent
        ).subscribe((updatedEvent: CalendarEventModel) => {
            const eventIndex = this.events.indexOf(event);
            this.events[eventIndex] = Object.assign(
                this.events[eventIndex],
                updatedEvent
            );
            this.refresh.next(true);
        });
    }

    editEvent(action: string, event: CalendarEvent) {
        if (event.title.includes('Block Days - ')) return;
        this.events = this.events.map((e) => ({
            ...e,
            cssClass: e == event ? 'event-active' : e.cssClass,
            meta: { selected: e === event }
        }));
        if (this.calendarConfig?.ViewEventCustom) {
            this.calendarConfig?.viewEventCustomCallback(
                    event,
                    this.calendarConfig
                );
        } else this.openDialog(action, event);
    }

    private openDialog(action: string, event: CalendarEvent) {
        this.dialogRef = this.dialog.open(
            PlatfromCalendarEventFormDialogComponent,
            {
                panelClass: 'event-form-dialog',
                data: {
                    event: event,
                    action: action,
                    hasPermissionToEdit:
                        this.calendarConfig?.EditEvent &&
                        !this.calendarConfig?.EditEventCustom,
                    hasPermissionToDelete:
                        this.calendarConfig?.DeleteEvent &&
                        !this.calendarConfig?.DeleteEventCustom    
                }
            }
        );

        this.dialogRef.afterClosed().subscribe((response) => {
            this.resetEventCSS();
            if (!response) {
                return;
            }
            const actionType: string = response[0];
            const formData: UntypedFormGroup = response[1];
            switch (actionType) {
                case 'save':
                    this.editEventDefault(event, formData?.value);
                    break;
                case 'delete':
                    this.deleteEvent(formData?.value);
                    break;
            }
        });
    }

    private resetEventCSS() {
        this.events.forEach((ev) => {
            if (ev.cssClass) {
                ev.cssClass = ev.meta?.selected ? '' : ev.cssClass;
                ev.meta.selected = false;
            }
        });
    }

    createNewEvent(eventInfo?: CalendarEventModel): any {
        this.createNewEventSubscribe = this.IAppPlatformCalendar.createNewEvent(
            eventInfo
        ).subscribe((event: CalendarEventModel) => {
            event.actions =
                this.actions?.length ? this.actions : null;
            this.events.push(event);
            this.refresh.next(true);
        });
    }

    addEvent(): void {
        if (
            this.calendarConfig?.hasPermissionToAddEvent &&
            this.calendarConfig.addEventCustom
        ) {
            this.calendarConfig?.addEventCustomCallback(this.calendarConfig);
        } else {
            this.dialogRef = this.dialog.open(
                PlatfromCalendarEventFormDialogComponent,
                {
                    panelClass: 'event-form-dialog',
                    data: {
                        action: 'new',
                        date: this.selectedDay.date,
                        hasPermissionToEdit:
                            this.calendarConfig?.hasPermissionToAddEvent,
                        hasPermissionToDelete:
                            this.calendarConfig?.hasPermissionToAddEvent
                    }
                }
            );
            this.dialogRef.afterClosed().subscribe((response: UntypedFormGroup) => {
                if (!response) {
                    return;
                }
                const newEvent = response.getRawValue();
                this.createNewEvent(newEvent);
            });
        }
    }

    syncEventsWithCalendar() {
        if (
            this.calendarConfig?.syncCalenarMedium == 'cronofy'
        ) {
            this.calendarService.getAuthorizationInCronofy(
                this.calendarConfig?.syncCalenarConfig?.clientId,
                this.calendarConfig?.syncCalenarConfig?.scope,
                this.calendarConfig?.syncCalenarConfig?.redirectUrl
            );
        } else if (
            this.calendarConfig?.syncCalenarMedium == 'kloudless'
        ) {
            this.calendarService.getAuthorizationInKloudless(
                this.calendarConfig?.syncCalenarConfig?.clientId,
                this.calendarConfig?.syncCalenarConfig?.scope,
                this.calendarConfig?.syncCalenarConfig?.redirectUrl
            );
        } else {
            // 1. Loop through each date group
            this.formatedSchedulesForListView = this.formatedSchedulesForListView.map(group => {
                return {
                    ...group,
                    events: group.events.map(event => {
                        const info = event.emebeddedInfo;
                        const isAdmin = info.LastActionTakenBypersonId !== this.personInfo.ItemId;
                        const leaveType = info.LeaveType ? info.LeaveType.toLowerCase() : '';
                        const isVacationOrOffDay = leaveType === "day-off" || leaveType === "vacation";
                        const isFullTimeEmployee = info && info.EmployeeCategory !== 'C';
                        return {
                            ...event,
                            emebeddedInfo: {
                                ...info,
                                isAssigned: isAdmin && isVacationOrOffDay && isFullTimeEmployee
                            }
                        };
                    })
                };
            });
            console.log("formatedSchedulesForListView with isAssigned", this.formatedSchedulesForListView);
            this.syncCalendarEvents.emit(this.formatedSchedulesForListView);
        }
    }

    OnGetCronofyCode(code) {
        this.syncCalendarEvents.emit(code);
    }

    syncEventsWithGoogleCalendar() {
        // this.calendarService.syncCalendarEvents(this.events);
        // this.socialSigninService.socialSigninBy('google');
        // this.socialSigninService.onSuccessSocialSignIn.subscribe(userData => {
        //     // localStorage.setItem("user", JSON.stringify(userData));
        //     this.listUpcomingEvents(userData);
        // });
        // let userData = localStorage.getItem("user") ;
        // if(userData){
        //     this.listUpcomingEvents(JSON.parse(userData));
        // }else{
        //     this.socialSigninService.socialSigninBy('google');
        //     this.socialSigninService.onSuccessSocialSignIn.subscribe(userData => {
        //         localStorage.setItem("user", JSON.stringify(userData));
        //         this.listUpcomingEvents(userData);
        //     });
        // }
    }

    // listUpcomingEvents(userData) {
    //     this.calendarService.getGoogleCalendarEvents(userData).subscribe((response: any) => {
    //         let googleCalendarEvents = response;
    //         console.log(googleCalendarEvents);
    //         this.calendarService.createCalendar(userData).subscribe(responseCreate => {
    //             console.log("Created Calendar: ");
    //             console.log(responseCreate);
    //             this.calendarService.insertGoogleCalendarEvents(userData, googleCalendarEvents && googleCalendarEvents.items[0]).subscribe(responseInsert => {
    //                 console.log("responseInsert: ");
    //                 console.log(responseInsert);
    //             });
    //         });

    //     });
    // }

    ngOnDestroy() {
        this.createNewEventSubscribe?.unsubscribe();
        this.editEventSubscribe?.unsubscribe();
        this.deleteEventSubscribe?.unsubscribe();
        this.getCalendarEventsSubscribe?.unsubscribe();
        this.OnEventDeletedSubscibe?.unsubscribe();
        this.OnEventAddedSubscribe?.unsubscribe();
        this.onEventUpdatedSubscribe?.unsubscribe();
        this.changePersonEventSubscription?.unsubscribe();
        this.OnReloadSubscibe?.unsubscribe();

        sessionStorage.removeItem(SCHEDULE_EVENT_FILTER_KEY);

        this._unsubscribeAll.next(null as any);
        this._unsubscribeAll.complete();
    }

    changeViewType(type) {
        this.selectedViewType = type;
        this.view = type;
        if (type !== 'schedule') {
            this.isScheduleView = false;
        } else {
            this.isScheduleView = true;
        }
        if (this.calendarService.fromEmModule.getValue()) {
            this.calendarService.OnCalendarViewChanged();
        } else if (this.isScheduleView) {
            this.getScheduleTabEvents(this.scheduleStartDate);
        } else {
            this.getEvents();
        }
        this.setQueryParams(type);
        this.scheduleCalendarService.calendarView.next(this.view);
    }

    getNextTwoMonthDates(startDate) {
        let currentDate = _moment(startDate);
        this.startDateForScheduleView = currentDate.format('DD');
        this.currentMonthName = currentDate.locale(this.locale).format('MMM');
        this.currentYear = currentDate.format('YYYY');
        const dateCollection = [];
        const endDate = _moment(currentDate).add(2, 'months');
        this.endDateForScheduleView = endDate.format('DD');
        this.nextSecondMonthName = endDate.locale(this.locale).format('MMM');
        this.nextYear = endDate.format('YYYY');
        while (currentDate <= endDate) {
            dateCollection.push(currentDate.startOf('day'));
            currentDate = _moment(currentDate).add(1, 'days');
        }
        return dateCollection;
    }

    getEventsForListView(startDate) {
        this.formatedSchedulesForListView = [];

        const dayCollection = this.getNextTwoMonthDates(startDate);
        if (this.events.length !== 0) {
            // const dayCollection = this.getNextTwoMonthDates(startDate);

            dayCollection.forEach((day) => {
                const formatedEventList = [];
                this.events.forEach((event) => {
                    
                    const start = _moment(event.start).startOf('day');
                    const end = _moment(event.end).endOf('day');
                    const embeddedInfo = (event as CalendarEventModel).emebeddedInfo;
                    const isWorkEvent = embeddedInfo?.ScheduleType === 'work';
                    const shouldIncludeByStartDateOnly = isWorkEvent && day.isSame(start, 'day');
                    const shouldIncludeByDateRange = !isWorkEvent && day >= start && day <= end;

                    if (shouldIncludeByStartDateOnly || shouldIncludeByDateRange) {
                        formatedEventList.push(event);
                        // console.log(event);
                    }
                });

                if (formatedEventList.length !== 0) {
                    const schedule = {
                        date: new Date(day),
                        events: formatedEventList
                    };
                    this.formatedSchedulesForListView.push(schedule);
                    console.log({formatedEventList});
                    console.log("formatedSchedulesForListView",this.formatedSchedulesForListView);

                }
            });
            console.log({dayCollection,formatedSchedulesForListView:this.formatedSchedulesForListView});
            this.syncEventsWithCalendar();
        }
    }

    isToday(date) {
        return _moment(date).isSame(_moment(), 'day');
    }
    identify(index, item) {
        return item.ItemId;
    }
}
